import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetRequiredMilesEffect } from './get-required-miles.effect';
import { getRequiredMilesReducer } from './get-required-miles.reducer';
import { GET_REQUIRED_MILES_STORE_NAME, GetRequiredMilesState } from './get-required-miles.state';

/** Token of the GetRequiredMiles reducer */
export const GET_REQUIRED_MILES_REDUCER_TOKEN = new InjectionToken<ActionReducer<GetRequiredMilesState, Action>>(
  'Feature GetRequiredMiles Reducer'
);

/** Provide default reducer for GetRequiredMiles store */
export function getDefaultGetRequiredMilesReducer() {
  return getRequiredMilesReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_REQUIRED_MILES_STORE_NAME, GET_REQUIRED_MILES_REDUCER_TOKEN),
    EffectsModule.forFeature([GetRequiredMilesEffect]),
  ],
  providers: [{ provide: GET_REQUIRED_MILES_REDUCER_TOKEN, useFactory: getDefaultGetRequiredMilesReducer }],
})
export class GetRequiredMilesStoreModule {
  public static forRoot<T extends GetRequiredMilesState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetRequiredMilesStoreModule> {
    return {
      ngModule: GetRequiredMilesStoreModule,
      providers: [{ provide: GET_REQUIRED_MILES_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
